var map = {
	"./buttoninfo.svg": 4197,
	"./buttoninfoactive.svg": 4637,
	"./buttonremove.svg": 4611,
	"./buttonremovehover.svg": 1413,
	"./iconadd.svg": 6932,
	"./logo.png": 4427,
	"./logo_beta_text.svg": 2976,
	"./sortasc.svg": 2030,
	"./sortdesc.svg": 4874
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;